// extracted by mini-css-extract-plugin
export var externalLink = "_a8-0";
export var internalLinkLabel = "_a8-1";